import React from "react";
import { cn } from "../../lib/utils";

export interface FilterTab {
  value: string;
  label: string;
  count?: number;
  disabled?: boolean;
}

export interface FilterTabsProps {
  tabs: FilterTab[];
  activeTab: string;
  onTabChange: (value: string) => void;
  className?: string;
  tabClassName?: string;
  activeTabClassName?: string;
}

export const FilterTabs: React.FC<FilterTabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className,
  tabClassName,
  activeTabClassName,
}) => {
  return (
    <div className={cn("flex gap-0 border-b border-gray-200", className)}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.value;
        return (
          <button
            key={tab.value}
            onClick={() => !tab.disabled && onTabChange(tab.value)}
            disabled={tab.disabled}
            className={cn(
              "relative pb-3 text-sm font-medium transition-all duration-200 min-w-32 h-11",
              "focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed",
              isActive
                ? cn("text-black", activeTabClassName)
                : "text-gray-500 hover:text-gray-700",
              tabClassName
            )}
          >
            <span className="flex justify-between items-center gap-2 pl-4 pr-2">
              {tab.label}
              {tab.count !== undefined && (
                <span
                  className={cn(
                    "flex justify-center px-1.5 py-0.5 h-6 w-6 items-center text-xs rounded-full min-w-6 text-center font-medium",
                    isActive
                      ? "bg-[#3AAE4B] text-white"
                      : "bg-gray-200 text-gray-600"
                  )}
                >
                  {tab.count}
                </span>
              )}
            </span>

            {isActive && (
              <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#AACC54] rounded-full" />
            )}
          </button>
        );
      })}
    </div>
  );
};
